module.exports = __webpack_public_path__ + "static/media/handsFreeErrorMsg.d3aead36.m4a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/handsFreeErrorMsg.m4a
// module id = 2833
// module chunks = 0